import { render } from "./cardsPage.vue?vue&type=template&id=487c0320"
import script from "./cardsPage.vue?vue&type=script&lang=js"
export * from "./cardsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__